/* eslint-disable */
<template>
  <div class="md-layout page-old-survey">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Missions") }}</h3>
      </md-toolbar>
      <br />
    </div>

    <div
      v-if="!show_mission_detail"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header>
          <md-button
            v-show="showNewSurveyBtn"
            :class="{ 'md-primary': surveyPageType === 'new' }"
            @click="toggleSurveytype('new')"
            >{{ $t("New Missions") }}</md-button
          >
          <md-button
            :class="{ 'md-primary': surveyPageType === 'old' }"
            @click="toggleSurveytype('old')"
          >
            {{ $t("Old Missions") }}
          </md-button>
        </md-card-header>
        <md-card-content>
          <md-table
            :value="surveys"
            class="paginated-table table-striped table-hover survey-list-table"
            @md-selected="showMissionDetail"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">{{ $t("Per page") }}</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="(item, position) in pagination.perPageOptions"
                    :key="position"
                    :label="item"
                    :value="item"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  ref="searchRef"
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  :placeholder="$t('Search')"
                  v-model="searchQuery"
                ></md-input>
              </md-field>
            </md-table-toolbar>
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              md-selectable="single"
            >
              <md-table-cell :md-label="$t('Date')">{{
                item.startTime
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Mission Name')">{{
                item.title
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Pilot')">{{
                item.pilot
              }}</md-table-cell>
              <md-table-cell :md-label="$t('RPAS')">{{
                item.rpas
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Reference No')">{{
                item.mission_reference_no
              }}</md-table-cell>
              <md-table-cell
                :md-label="$t('Status')"
                :class="{
                  'text-danger': item.status == 'aborted',
                  'text-warning':
                    item.status == 'pending' ||
                    item.status == 'checklist in progress',
                  'text-success': item.status == 'checklist completed'
                }"
                >{{ item.status }}
              </md-table-cell>
              <md-table-cell :md-label="$t('Notice')">
                <span
                  v-if="
                    item.controlled &&
                      partnerAirports &&
                      partnerAirports.hasOwnProperty(
                        item.nearestAerodromes.split(',')[0]
                      ) &&
                      partnerAirports[item.nearestAerodromes.split(',')[0]]
                        .notice
                  "
                  class="material-icons"
                  :style="item.permission ? 'color: #285fac' : 'color: red'"
                >
                  flight_takeoff
                </span></md-table-cell
              >
              <md-table-cell
                v-if="usertype !== USER_TYPE.AIRPORT"
                :md-label="$t('Clone')"
              >
                <span
                  @click.stop="cloneMission(item)"
                  class="material-icons"
                  style="color: #0ABAB5; font-size: 18px;"
                >
                  content_copy
                </span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              {{
                $t("Showing") +
                  " " +
                  (pagination.total === 0
                    ? 0
                    : (pagination.currentPage - 1) * pagination.perPage + 1) +
                  " " +
                  $t("to") +
                  " " +
                  (pagination.currentPage * pagination.perPage >
                  pagination.total
                    ? pagination.total
                    : pagination.currentPage * pagination.perPage) +
                  " " +
                  $t("of") +
                  " " +
                  pagination.total +
                  " " +
                  $t("entries")
              }}
            </p>
          </div>
          <pagination
            class="pagination-no-border"
            :value="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            @pageChange="onPagination"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>

    <div
      v-if="show_mission_detail"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">
              {{ $t("Mission Detail") }}
              <span v-if="mission.mission_reference_no"
                >(&nbsp;{{ $t("Reference No") }}:
                {{ mission.mission_reference_no }}&nbsp;)</span
              >
            </h4>
          </div>
          <br />
          <md-button
            class="md-primary"
            style="width:200px"
            @click="showMissionDetail()"
            >Go Back</md-button
          >
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div
              class="md-layout-item md-medium-size-48 md-xsmall-size-100 md-size-48"
            >
              <md-list class="md-double-line">
                <div
                  class="notice-wrapper"
                  :class="mission.permission ? '' : 'active'"
                  v-if="
                    usertype !== USER_TYPE.AIRPORT &&
                      mission.controlled &&
                      partnerAirports &&
                      partnerAirports.hasOwnProperty(
                        mission.nearestAerodromes.split(',')[0]
                      )
                  "
                >
                  <md-subheader class="notice-title"
                    >{{ $t("Notice")
                    }}<span class="material-icons">
                      warning_amber
                    </span></md-subheader
                  >
                  <!-- eslint-disable -->
                  <div class="notice-content">
                    <div class="tips">
                      {{
                        $t(
                          "Note: By checking the box below, you acknowledge that you have secured the required permission from NAV CANADA for this mission. As part of our partnership with the airport, this action will automatically notify the airport of your authorization status."
                        )
                      }}
                    </div>
                    <md-checkbox
                      v-model="mission.permission"
                      @change="changePermissionStatus"
                      >{{
                        $t(
                          "I have been granted permission from NAV CANADA for this mission."
                        )
                      }}</md-checkbox
                    >
                  </div>
                  <!-- eslint-enable -->
                  <md-list-item>
                    <div class="md-layout algin-center">
                      <div
                        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-40"
                      >
                        <md-icon class="">library_books</md-icon>
                        <div class="" style="display: contents;">
                          <span>&nbsp;&nbsp;{{ $t("Airport notice") }}</span>
                        </div>
                      </div>
                      <div
                        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-35"
                      >
                        <div class="">
                          <a
                            target="blank"
                            :href="mission.noticeUrl"
                            style="font-size : 12px;"
                          >
                            <md-button
                              class="md-primary"
                              style="width:150px"
                              :disabled="mission.noticeUrl === ''"
                            >
                              {{ $t("VIEW PDF") }}
                            </md-button>
                          </a>
                        </div>
                      </div>
                      <div
                        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-30"
                      ></div>
                    </div>
                  </md-list-item>
                </div>

                <md-subheader>MAP</md-subheader>
                <md-list-item class="md-inset">
                  <div class="md-layout">
                    <div
                      class="md-layout-item md-small-size-100 md-size-90"
                      @click="showDialog = true"
                      style="max-height: 350px;overflow: scroll; "
                    >
                      <!--<img :src="mission.img">-->
                      <img :src="mission.img" class="" />
                    </div>
                  </div>
                </md-list-item>

                <br />
                <br />

                <md-subheader>{{ $t("Operation Plan") }}</md-subheader>
                <md-list-item class="md-inset">
                  <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Mission Start") }}</label>
                        <md-input
                          v-model="mission.startTimeLocal"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Mission End") }}</label>
                        <md-input
                          v-model="mission.endTimeLocal"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-list-item>
                <md-list-item class="md-inset">
                  <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Latitude") }}</label>
                        <md-input
                          v-model="mission.latitude"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Longitude") }}</label>
                        <md-input
                          v-model="mission.longitude"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-list-item>
                <md-list-item>
                  <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-30">
                      <md-field>
                        <label>{{ $t("Operation Radius") }}</label>
                        <md-input
                          v-model="mission.operationradiusunit"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-30">
                      <md-field>
                        <label>{{ $t("Controlled") }}</label>
                        <md-input
                          :value="mission.controlled ? 'YES' : 'NO'"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-35">
                      <md-field>
                        <label>{{ $t("FIR") }}</label>
                        <md-input v-model="mission.fir" disabled></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-list-item>
                <md-list-item>
                  <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-100">
                      <md-field>
                        <label>{{ $t("Nearest Aerodromes") }}</label>
                        <md-input
                          v-model="mission.nearestAerodromes"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-list-item>
                <md-list-item v-if="mission.controlled">
                  <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-100">
                      <md-field>
                        <label>{{
                          $t("NAV CANADA permission acknowledgement")
                        }}</label>
                        <md-input
                          :value="mission.permission ? $t('Yes') : $t('No')"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-list-item>
              </md-list>
            </div>

            <div
              class="md-layout-item md-medium-size-48 md-xsmall-size-100 md-size-48"
            >
              <md-list class="md-double-line">
                <md-subheader>{{ $t("Operation Crew") }}</md-subheader>
                <md-list-item>
                  <div class="md-layout">
                    <div
                      v-if="mission.projectname"
                      class="md-layout-item md-small-size-100 md-size-90"
                    >
                      <md-field>
                        <label>{{ $t("Project Name") }}</label>
                        <md-input
                          v-model="mission.projectname"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Pilot Name") }}</label>
                        <md-input
                          v-model="mission.pilotname"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Pilot License") }}</label>
                        <md-input
                          v-model="mission.pilotlicense"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Pilot Email") }}</label>
                        <md-input
                          :value="mission.pilotemail || mission.email"
                          disabled
                        ></md-input>
                        <span
                          v-if="mission.pilotemail || mission.email"
                          v-clipboard="mission.pilotemail || mission.email"
                          class="material-icons copy-icon"
                          v-clipboard:success="clipboardCbfn"
                        >
                          content_copy
                        </span>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Pilot Phone") }}</label>
                        <md-input
                          v-model="mission.pilotphone"
                          disabled
                        ></md-input>
                        <span
                          v-if="mission.pilotphone"
                          v-clipboard="mission.pilotphone"
                          class="material-icons copy-icon"
                          v-clipboard:success="clipboardCbfn"
                        >
                          content_copy
                        </span>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Observer") }}</label>
                        <md-input
                          v-model="mission.observername"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Payload Operator") }}</label>
                        <md-input
                          v-model="mission.payloadoperatorname"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-list-item>

                <md-subheader>{{ $t("RPAS") }}</md-subheader>

                <md-list-item>
                  <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-80">
                      <md-field>
                        <label>{{ $t("RPAS") }}</label>
                        <md-input
                          v-model="mission.dronemodel"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-40">
                      <md-field>
                        <label>{{ $t("Registration Number") }}</label>
                        <md-input
                          v-model="mission.droneregistrationnumber"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-40">
                      <md-field>
                        <label>{{ $t("Drone ID / Serial Number") }}</label>
                        <md-input
                          v-model="mission.serialno"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-40">
                      <md-field>
                        <label>{{ $t("RPAS Colour") }}</label>
                        <md-input
                          v-model="mission.dronecolor"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-list-item>

                <md-subheader>{{ $t("Weather") }}</md-subheader>

                <md-list-item>
                  <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-80">
                      <md-field>
                        <label>{{ $t("Details") }}</label>
                        <md-input
                          v-model="mission.weather_description"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Conditions") }}</label>
                        <md-input
                          v-model="mission.weather_condition"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Temperature") }}</label>
                        <md-input
                          v-model="mission.weather_temp_unit"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Feels Like") }}</label>
                        <md-input
                          v-model="mission.weather_feelslike_unit"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Precipitation") }}</label>
                        <md-input
                          v-model="mission.weather_precipprob_unit"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Visibility") }}</label>
                        <md-input
                          v-model="mission.weather_visibility_unit"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Cloud Coverage") }}</label>
                        <md-input
                          v-model="mission.weather_cloudcover_unit"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Wind Speed") }}</label>
                        <md-input
                          v-model="mission.weather_windspeed_unit"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Humidity") }}</label>
                        <md-input
                          v-model="mission.weather_humidity_unit"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-list-item>

                <md-subheader>{{ $t("Documents") }}</md-subheader>
                <md-list-item>
                  <div class="md-layout items-center">
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 document-title"
                    >
                      <md-icon class="">library_books</md-icon>
                      <div class="" style="display: contents;">
                        <span>&nbsp;&nbsp;{{ $t("Site Survey") }}</span>
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-35"
                    >
                      <div class="">
                        <a
                          target="blank"
                          :href="mission.pdf"
                          style="font-size : 12px;"
                        >
                          <md-button
                            class="md-primary"
                            style="width:150px"
                            :disabled="mission.pdf === ''"
                          >
                            {{ $t("VIEW PDF") }}
                          </md-button>
                        </a>
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 document-title"
                    ></div>
                  </div>
                </md-list-item>
                <md-list-item
                  v-if="
                    !(
                      usertype === USER_TYPE.FREE ||
                      usertype === USER_TYPE.AIRPORT
                    )
                  "
                >
                  <div class="md-layout items-center">
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 document-title"
                    >
                      <md-icon class="">assignment_turned_in</md-icon>
                      <div class="" style="display: contents;">
                        <span>&nbsp;&nbsp;{{ $t("Mission Report") }}</span>
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-35"
                    >
                      <div class="">
                        <a
                          v-if="mission.mission_pdf !== ''"
                          target="blank"
                          :href="mission.mission_pdf"
                          style="font-size : 12px; "
                        >
                          <md-button class="md-primary" style="width:150px">
                            {{ $t("VIEW PDF") }}
                          </md-button>
                        </a>

                        <md-button
                          class="md-primary"
                          style="width:150px"
                          @click="reloadPage()"
                          v-else-if="
                            mission.mission_generate &&
                              (mission.status === 'checklist completed' ||
                                mission.status === 'aborted')
                          "
                        >
                          {{ $t("Reload Page") }}</md-button
                        >
                        <md-button
                          class="md-primary"
                          style="width:150px"
                          @click="generateMissionReport()"
                          v-else-if="
                            mission.status === 'checklist completed' ||
                              mission.status === 'aborted'
                          "
                        >
                          {{ $t("GENERATE PDF") }}</md-button
                        >
                        <a v-else target="blank" style="font-size : 12px; ">
                          <md-button
                            class="md-primary"
                            style="width:150px"
                            disabled
                          >
                            {{ $t("VIEW PDF") }}
                          </md-button>
                        </a>
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-35"
                    >
                      <div
                        class=""
                        v-if="
                          mission.mission_pdf !== '' &&
                            mission.mission_csv !== ''
                        "
                      >
                        <a
                          v-if="
                            usertype === USER_TYPE.ADMIN ||
                              usertype === USER_TYPE.ENTERPRISE ||
                              usertype === USER_TYPE.SUPER
                          "
                          target="blank"
                          :href="mission.mission_csv"
                          style="font-size : 12px; "
                        >
                          <md-button class="md-primary" style="width:150px;">
                            {{ $t("DOWNLOAD CSV") }}
                          </md-button>
                        </a>
                      </div>
                    </div>
                  </div>
                </md-list-item>
                <md-list-item
                  v-if="
                    mission.survey_type === SURVEY_TYPE.REVIEWER &&
                      surveyPageType === 'old' &&
                      !mission.mission_pdf
                  "
                >
                  <div class="md-layout items-center">
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 document-title"
                    >
                      <md-icon class="">rule</md-icon>
                      <div class="" style="display: contents;">
                        <span
                          >&nbsp;&nbsp;{{ $t("Flight Review Checklist") }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-35"
                    >
                      <a
                        v-if="mission.flightReviewRubricUrl"
                        target="blank"
                        :href="
                          FLIGHT_REVIEW_RUBRIC_URL +
                            mission.flightReviewRubricUrl
                        "
                        style="font-size : 12px;"
                      >
                        <md-button class="md-primary" style="width:150px">
                          {{ $t("VIEW PDF") }}
                        </md-button>
                      </a>

                      <md-button
                        v-else
                        class="md-fileinput md-primary"
                        style="width:150px"
                      >
                        <template>{{ $t("Upload") }}</template>
                        <input type="file" @change="onUploadRubric" />
                      </md-button>

                      <md-button
                        v-if="mission.flightReviewRubricUrl"
                        style="width:150px"
                        @click="deleteRubric"
                      >
                        {{ $t("Delete") }}
                      </md-button>
                    </div>
                  </div>
                </md-list-item>
                <md-list-item v-if="usertype !== USER_TYPE.AIRPORT">
                  <div class="">
                    <md-button
                      v-if="usertype !== USER_TYPE.PILOT"
                      class="md-primary"
                      style="width:200px"
                      @click="deleteMission()"
                      >{{ $t("Delete Mission") }}</md-button
                    >
                  </div>
                </md-list-item>
              </md-list>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <div
      v-show="show_mission_stream"
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-49"
    >
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>list_alt</md-icon>
          </div>
          <h4 class="title">{{ $t("Live Streaming") }}</h4>
        </md-card-header>
        <md-card-content>
          <div
            style="margin:40px 0px"
            v-if="mission.player_url !== undefined && !streaming"
          >
            <label>{{ $t("Mission Footage") }}</label>
          </div>
          <div style="margin:40px 0px" v-else>
            <md-button
              class="md-primary"
              @click="setLiveStreaming(streaming)"
              >{{
                this.streaming ? $t("Stop Live Event") : $t("Start Live Event")
              }}</md-button
            >
          </div>
          <div>
            <video
              id="azuremediaplayer"
              class="azuremediaplayer amp-default-skin amp-big-play-centered"
              tabindex="0"
            ></video>
          </div>
          <div
            style="margin:40px 0px"
            v-if="mission.player_url === undefined || streaming"
          >
            <md-button class="md-primary" @click="refreshPlayer()">{{
              $t("Refresh Player")
            }}</md-button>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <div>
      <md-dialog :md-active.sync="showDialog">
        <md-dialog-title>MAP Image</md-dialog-title>
        <div style="max-height: 650px;max-width: 800px;overflow: scroll; ">
          <img class="" :src="mission.img" />
        </div>
        <md-dialog-actions>
          <md-button class="md-primary" @click="showDialog = false"
            >Close</md-button
          >
        </md-dialog-actions>
      </md-dialog>
    </div>
    <Toast ref="toast"></Toast>
  </div>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import { mapFields } from "vuex-map-fields";
import { Pagination } from "@/components";
import swal from "sweetalert2";
import { EventBus, NOTICE_URL, FLIGHT_REVIEW_RUBRIC_URL } from "@/helpers";
import { router } from "../../main";
import { USER_TYPE, SURVEY_TYPE } from "../../const";
import moment from "moment";
import { debounce } from "@/helpers/utils";
import Toast from "@/components/Toast.vue";
import {
  getallpartners,
  updatePermissionStatus,
  flightReviewRubricUpdate,
  deleteFlightReviewRubric
} from "@/services/survey.service.js";

const { mapMultiRowFields } = createHelpers({
  mutationType: "updateSurveyField"
});

export default {
  name: "oldsurvey",
  components: {
    Pagination,
    Toast
  },
  computed: {
    ...mapMultiRowFields("survey", ["surveys"]),
    ...mapFields("survey", ["pagination"]),
    ...mapMultiRowFields("setting", ["drones"]),
    ...mapFields("auth", ["quantity", "plan_type", "usertype", "airport_id"]),
    ...mapFields("airport", ["notice"]),
    showNewSurveyBtn() {
      if (this.loadNewSurveyAndGetNone) {
        return false;
      }
      // free can't see newSurvey
      if (this.usertype === this.USER_TYPE.FREE) return false;

      // no coming survey hide the btn
      if (
        this.usertype &&
        this.surveyPageType === "new" &&
        this.pagination.total === 0
      ) {
        this.toggleSurveytype("old");

        // to record no new survey status
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.loadNewSurveyAndGetNone = true;
        return false;
      }
      return true;
    }
  },
  data() {
    return {
      USER_TYPE: USER_TYPE,
      FLIGHT_REVIEW_RUBRIC_URL,
      SURVEY_TYPE,
      //footerTable: ["Client", "RPA", "Pilot", "Address", "Airspace", "Start", "End", "Status", "Survey PDF"],
      searchQuery: "",
      propsToSearch: ["startTime", "rpas", "pilotname", "title", "status"],
      searchedData: [],
      fuseSearch: null,
      deletingSiteSurvey: false,
      editingFlightLogs: false,
      editingSiteSurvey: false,
      flightlogs: [],
      event: null,
      start: "",
      end: "",
      errorMsg: "",
      position: 0,
      streaming: false,
      show_mission_detail: false,
      show_mission_stream: false,
      showDialog: false,
      mission: {
        id: "",
        permission: false,
        manufacturer: "",
        rpas: "",
        dronemodel: "",
        droneregistrationnumber: "",
        projectname: "",
        pilotname: "",
        pilotphone: "",
        pilotemail: "",
        pilotlicense: "",
        observername: "",
        payloadoperatorname: "",
        radiusunit: "",
        operationaltitude: "",
        email: "",
        fir: "",
        address: "",
        latitude: 0.0,
        longitude: 0.0,
        img: "",
        title: "",
        start: null,
        end: null,
        startLocal: "",
        endLocal: "",
        pdf: "",
        pdf_file: "",
        mission_pdf: "",
        mission_csv: "",
        mission_generate: false,
        noticeUrl: "",
        operationradius: 0.0,
        operationradiusunit: "",
        dronecolor: "",
        serialno: "",
        controlled: false,
        nearestAerodromes: null,
        status: "",
        weather_condition: "",
        weather_temp: 0.0,
        weather_temp_unit: "",
        weather_feelslike: 0.0,
        weather_weather_feelslike_unit: "",
        weather_precipprob: 0.0,
        weather_weather_precipprob_unit: "",
        weather_visibility: 0.0,
        weather_weather_visibility_unit: "",
        weather_cloudcover: 0,
        weather_weather_cloudcover_unit: "",
        weather_windspeed: 0.0,
        weather_weather_windspeed_unit: "",
        weather_humidity: 0.0,
        weather_weather_humidity_unit: "",
        weather_description: "",
        mission_reference_no: "",
        flightReviewRubricUrl: "",
        survey_type: "",
        clientEmail: ""
      },
      surveyPageType: "new", // old, new
      debouncedSurveysSearch: debounce(this.getSurveys, 300),
      debouncedAirportSurveySearch: debounce(this.getAirportSurveys, 300),
      loadNewSurveyAndGetNone: false,
      partnerAirports: {},
      fileType: "",
      rubricData: null,
      selectedFile: ""
    };
  },
  methods: {
    closeFlightLogsEditor() {
      this.editingFlightLogs = false;
    },
    closeSiteSurveyEditor() {
      this.editingSiteSurvey = false;
    },
    addFlightLog() {
      this.flightlogs.push({
        start_time: {
          HH: "",
          mm: ""
        },
        end_time: {
          HH: "",
          mm: ""
        }
      });
    },
    deleteFlightLog(index) {
      this.flightlogs.splice(index, 1);
    },
    saveFlightLogs() {
      this.editingFlightLogs = false;
      this.$store.dispatch("survey/saveFlightLogs", {
        event: {
          pdf: this.event.pdf,
          start: this.event.start,
          end: this.event.end
        },
        flightlogs: this.flightlogs
      });
    },
    saveSiteSurvey() {
      this.errorMsg = "";
      var dtStart = new Date(this.start);
      var dtEnd = new Date(this.end);
      if (dtStart < new Date()) {
        this.errorMsg = "Can't schedule flight in the past.";
      } else if (dtStart > dtEnd) {
        this.errorMsg = "End time can't be earlier than start time.";
      } else if (
        dtStart.getFullYear() !== dtEnd.getFullYear() ||
        dtStart.getMonth() !== dtEnd.getMonth() ||
        dtStart.getDate() !== dtEnd.getDate()
      ) {
        this.errorMsg = "Start time and end time have to be on the same date.";
      }

      if (this.errorMsg !== "") return;

      this.editingSiteSurvey = false;
      this.$store.dispatch("survey/saveEvent", {
        start: this.event.start,
        end: this.event.end,
        newStart: this.start,
        newEnd: this.end,
        startLocal: moment(this.start).format("LLL"),
        endLocal: moment(this.end).format("LLL")
      });
    },
    showMissionDetail(mission) {
      console.log(this.surveys, mission);
      if (mission != null && !this.show_mission_stream) {
        this.show_mission_detail = true;
        this.mission.id = mission.id;
        this.mission.permission = mission.permission;
        this.mission.manufacturer = mission.manufacturer;
        this.mission.rpas = mission.rpas;
        this.mission.dronemodel = mission.manufacturer + " - " + mission.rpas;
        this.mission.droneregistrationnumber = mission.droneregistrationnumber;
        this.mission.projectname = mission.projectname;
        this.mission.pilotname = mission.pilot;
        this.mission.pilotphone = mission.pilotphone;
        this.mission.pilotemail = mission.pilotemail;
        this.mission.pilotlicense = mission.pilotlicense;
        this.mission.observername = mission.observername;
        this.mission.payloadoperatorname = mission.payloadoperatorname;
        this.mission.address = mission.address;
        this.mission.title = mission.title;
        this.mission.start = mission.start;
        this.mission.end = mission.end;
        this.mission.startTimeLocal = mission.startTimeLocal;
        this.mission.endTimeLocal = mission.endTimeLocal;
        this.mission.pdf = mission.pdf;
        this.mission.pdf_file = mission.pdf_file;
        this.mission.mission_pdf = mission.mission_pdf;
        this.mission.mission_csv = mission.mission_csv;
        this.mission.mission_generate = mission.mission_generate;
        this.mission.email = mission.email;
        this.mission.operationradius = mission.operationradius;
        this.mission.radiusunit = mission.radiusunit;
        this.mission.operationradiusunit =
          mission.operationradius + " " + mission.radiusunit;
        this.mission.dronecolor = mission.dronecolor;
        this.mission.serialno = mission.serialno;
        this.mission.controlled = mission.controlled;
        this.mission.fir = mission.fir;
        this.mission.nearestAerodromes = mission.nearestAerodromes;
        this.mission.status = mission.status;
        this.mission.latitude = mission.latitude;
        this.mission.longitude = mission.longitude;
        this.mission.weather_avail = mission.weather_avail;
        this.mission.img = mission.img;
        this.mission.mission_reference_no = mission.mission_reference_no;
        this.mission.flightReviewRubricUrl = mission.flightReviewRubricUrl;
        this.mission.survey_type = mission.survey_type;
        this.mission.clientEmail = mission.clientEmail;
        if (this.mission.weather_avail) {
          this.mission.weather_condition = mission.weather_condition;
          this.mission.weather_temp = mission.weather_temp;
          this.mission.weather_temp_unit = mission.weather_temp + " °C";
          this.mission.weather_feelslike = mission.weather_feelslike;
          this.mission.weather_feelslike_unit =
            mission.weather_feelslike + " °C";
          this.mission.weather_precipprob = mission.weather_precipprob;
          this.mission.weather_precipprob_unit =
            mission.weather_precipprob + " %";
          this.mission.weather_visibility = mission.weather_visibility;
          this.mission.weather_visibility_unit =
            mission.weather_visibility + " Km";
          this.mission.weather_cloudcover = mission.weather_cloudcover;
          this.mission.weather_cloudcover_unit =
            mission.weather_cloudcover + " %";
          this.mission.weather_windspeed = mission.weather_windspeed;
          this.mission.weather_windspeed_unit =
            mission.weather_windspeed + " Kph";
          this.mission.weather_humidity = mission.weather_humidity;
          this.mission.weather_humidity_unit = mission.weather_humidity + " %";
          this.mission.weather_description = mission.weather_description;
        }
        if (mission.controlled) {
          this.$store.dispatch(
            "airport/getNotice",
            mission.nearestAerodromes.split(",")[0]
          );
        }
      } else {
        this.show_mission_detail = false;
        this.mission.id = "";
        this.mission.manufacturer = "";
        this.mission.rpas = "";
        this.mission.dronemodel = "";
        this.mission.droneregistrationnumber = "";
        this.mission.pilotname = "";
        this.mission.projectname = "";
        this.mission.pilotphone = "";
        this.mission.pilotemail = "";
        this.mission.pilotlicense = "";
        this.mission.observername = "";
        this.mission.payloadoperatorname = "";
        this.mission.controlled = false;
        this.mission.address = "";
        this.mission.title = "";
        this.mission.start = "";
        this.mission.end = "";
        this.mission.startTimeLocal = "";
        this.mission.endTimeLocal = "";
        this.mission.pdf = "";
        this.mission.pdf_file = "";
        this.mission.mission_pdf = "";
        this.mission.mission_csv = "";
        this.mission.mission_generate = "";
        this.mission.noticeUrl = "";
        this.mission.email = "";
        this.mission.operationradius = "";
        this.mission.radiusunit = "";
        this.mission.operationradiusunit = "";
        this.mission.dronecolor = "";
        this.mission.serialno = "";
        this.mission.controlled = false;
        this.mission.fir = "";
        this.mission.nearestAerodromes = "";
        this.mission.status = "";
        this.mission.latitude = "";
        this.mission.longitude = "";
        this.mission.weather_avail = "";
        this.mission.weather_condition = "";
        this.mission.weather_temp = "";
        this.mission.weather_temp_unit = "";
        this.mission.weather_feelslike = "";
        this.mission.weather_feelslike_unit = "";
        this.mission.weather_precipprob = "";
        this.mission.weather_precipprob_unit = "";
        this.mission.weather_visibility = "";
        this.mission.weather_visibility_unit = "";
        this.mission.weather_cloudcover = "";
        this.mission.weather_cloudcover_unit = "";
        this.mission.weather_windspeed = "";
        this.mission.weather_windspeed_unit = "";
        this.mission.weather_humidity = "";
        this.mission.weather_humidity_unit = "";
        this.mission.weather_description = "";
        this.mission.img = "";
        this.mission.mission_reference_no = "";
        this.mission.flightReviewRubricUrl = "";
        this.mission.survey_type = "";
        this.mission.clientEmail = "";
      }
    },
    showMissionStream(mission) {
      this.mission = mission;

      if (mission != null) {
        this.show_mission_stream = true;

        this.refreshPlayer();
      } else {
        this.show_mission_stream = false;
      }
    },
    setLiveStreaming(streaming) {
      this.streaming = !this.streaming;
      this.$store.dispatch("survey/setLiveStreaming", {
        license: this.mission.pilotlicense,
        channel_id: this.drones.find(
          drone =>
            drone.registrationnumber === this.mission.droneregistrationnumber
        ).channel_id,
        start: this.mission.start,
        streaming: !streaming
      });
    },
    refreshPlayer() {
      /*var myOptions = {
        autoplay: false,
        controls: true,
        heuristicProfile: "LowLatency",
        nativeControlsForTouch: false,
        logo: {
          enabled: false
        },
        fluid: true,
        playbackSpeed: {
          enabled: true,
          initialSpeed: 1.0,
          speedLevels: [
            { name: "x4.0", value: 4.0 },
            { name: "x3.0", value: 3.0 },
            { name: "x2.0", value: 2.0 },
            { name: "x1.75", value: 1.75 },
            { name: "x1.5", value: 1.5 },
            { name: "x1.25", value: 1.25 },
            { name: "x1.0", value: 1.0 },
            { name: "x0.75", value: 0.75 },
            { name: "x0.5", value: 0.5 }
          ]
        },
        height: "auto",
        width: "100%"
      };
      var myPlayer = amp("azuremediaplayer", myOptions);
      myPlayer.addEventListener("error", function() {
        var errorDetails = myPlayer.error();
        var code = errorDetails.code;
        var message = errorDetails.message;
        console.log(code + ":" + message);
      });
      myPlayer.src([
        {
          src:
            //"http://amssamples.streaming.mediaservices.windows.net/622b189f-ec39-43f2-93a2-201ac4e31ce1/BigBuckBunny.ism/manifest",
            this.mission.player_url,
          type: "application/vnd.ms-sstr+xml"
        }
      ]);*/
    },
    deleteMission() {
      let _self = this;
      swal
        .fire({
          title: this.$t("Warning"),
          text: this.$t(
            "Selected mission and associated data will be deleted permanently."
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$store.dispatch("survey/deleteMission", {
              status: this.mission.status,
              email: this.mission.email,
              start: this.mission.start,
              end: this.mission.end,
              onDeleteSuccess() {
                if (_self.usertype === USER_TYPE.AIRPORT) {
                  _self.getAirportSurveys(
                    _self.pagination.currentPage,
                    _self.pagination.perPage,
                    _self.searchQuery
                  );
                } else {
                  _self.getSurveys(
                    _self.pagination.currentPage,
                    _self.pagination.perPage,
                    _self.searchQuery
                  );
                }
              }
            });
            this.show_mission_detail = false;
          }
        });
    },
    generateMissionReport() {
      swal
        .fire({
          title: this.$t("Mission Report"),
          text: this.$t(
            "The mission report will be available in PDF shortly. Please allow 10 - 15 seconds for file to be generated."
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$store.dispatch("survey/generateMissionReport", {
              license: this.mission.pilotlicense,
              start: this.mission.start,
              end: this.mission.end
              // onGenerateMissionReportSuccess(res) {}
            });
            this.show_mission_detail = false;
            router.go();
          }
        });
    },
    reloadPage() {
      router.go();
    },
    toggleSurveytype(type) {
      this.surveyPageType = type;

      this.$store.commit("survey/setPagination", {
        ...this.pagination,
        currentPage: 1
      });

      // md-input bug, when this.searchQuery = "", input value still in the page
      this.searchQuery = "";
      this.$refs.searchRef && this.$refs.searchRef.clearField();
      if (this.usertype === USER_TYPE.AIRPORT) {
        this.getAirportSurveys(
          this.pagination.currentPage,
          this.pagination.perPage,
          this.searchQuery
        );
      } else {
        this.getSurveys(
          this.pagination.currentPage,
          this.pagination.perPage,
          this.searchQuery
        );
      }
    },
    getAirportSurveys(currentPage = 1, perPage = 10, keywords) {
      this.$store.dispatch("survey/getAirportSurveys", {
        airportId: this.airport_id,
        type: this.surveyPageType,
        currentPage,
        perPage,
        keywords
      });
    },
    getSurveys(currentPage = 1, perPage = 10, keywords) {
      let beginTime, endTime;
      // free user only get 7 days
      if (this.usertype === USER_TYPE.FREE) {
        // free use no newSurveys
        if (this.surveyPageType === "new") {
          return;
        } else {
          // past 7 days
          endTime = +new Date();
          beginTime = endTime - 7 * 24 * 60 * 60 * 1000;
        }
      }
      this.$store.dispatch("survey/getSurveys", {
        type: this.surveyPageType,
        beginTime,
        endTime,
        currentPage,
        perPage,
        keywords
      });
    },
    onPagination(currentPage) {
      if (this.usertype === USER_TYPE.AIRPORT) {
        this.getAirportSurveys(
          currentPage,
          this.pagination.perPage,
          this.searchQuery
        );
      } else {
        this.getSurveys(currentPage, this.pagination.perPage, this.searchQuery);
      }
    },
    initSurveys(usertype) {
      if (usertype === USER_TYPE.AIRPORT) {
        this.getAirportSurveys(
          this.pagination.currentPage,
          this.pagination.perPage,
          this.searchQuery
        );
      } else if (usertype === USER_TYPE.FREE) {
        this.surveyPageType = "old";
        this.getSurveys(
          this.pagination.currentPage,
          this.pagination.perPage,
          this.searchQuery
        );
      } else {
        this.getSurveys(
          this.pagination.currentPage,
          this.pagination.perPage,
          this.searchQuery
        );
      }
    },
    clipboardCbfn() {
      this.$refs.toast.showToast(this.$t("Copied"));
    },
    changePermissionStatus(val) {
      updatePermissionStatus(this.surveyPageType, {
        permission: val,
        id: this.mission.id
      }).then(() => {
        this.$notify({
          message: this.$t("Permission status update successful"),
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
          timeout: 3000
        });
      });
    },
    onUploadRubric(e) {
      var self = this;
      const file = e.target.files[0];
      this.selectedFile = file.name;
      var fileReader = new FileReader();
      fileReader.onload = function(fileLoadedEvent) {
        var base64 = fileLoadedEvent.target.result;
        flightReviewRubricUpdate(self.surveyPageType, {
          id: self.mission.id,
          flightReviewRubricData: base64.split(",")[1],
          fileType: file.type,
          clientEmail: self.mission.clientEmail,
          flightReviewRubricUrl: self.mission.flightReviewRubricUrl
        }).then(res => {
          self.getSurveys(
            self.pagination.currentPage,
            self.pagination.perPage,
            self.searchQuery
          );
          self.mission.flightReviewRubricUrl = res;
        });
      };
      fileReader.readAsDataURL(file);
    },
    deleteRubric() {
      deleteFlightReviewRubric(this.surveyPageType, {
        id: this.mission.id,
        flightReviewRubricUrl: this.mission.flightReviewRubricUrl
      }).then(() => {
        this.getSurveys(
          this.pagination.currentPage,
          this.pagination.perPage,
          this.searchQuery
        );
        this.mission.flightReviewRubricUrl = "";
      });
    },
    cloneMission(mission) {
      this.$store.commit("survey/setSurveyDraftFromClone", mission);
      this.$store.commit("survey/setIsclone", true);
      this.$router.push("/newsurvey");
    }
  },
  mounted() {
    // mounted load survey
    if (this.usertype) {
      this.initSurveys(this.usertype);
    }

    // For refresh page, waitting user info first, before get airportSurveys
    EventBus.$on("getUserProfile", userInfo => {
      this.initSurveys(userInfo.usertype);
    });

    EventBus.$on("setNotice", () => {
      if (this.notice) {
        this.$set(
          this.mission,
          "noticeUrl",
          NOTICE_URL + this.mission.nearestAerodromes.split(",")[0] + ".pdf"
        );
        console.log(this.mission.noticeUrl);
      }
    });

    // getall partners for display notice
    getallpartners().then(res => {
      this.partnerAirports = res;
    });
  },
  beforeDestroy() {
    EventBus.$off("getUserProfile");
    EventBus.$off("setNotice");
  },
  watch: {
    searchQuery(value) {
      let { perPage } = this.pagination;
      this.$store.commit("survey/setPagination", {
        ...this.pagination,
        currentPage: 1
      });
      if (this.usertype === USER_TYPE.AIRPORT) {
        this.debouncedAirportSurveySearch(1, perPage, value);
      } else {
        this.debouncedSurveysSearch(1, perPage, value);
      }
    },
    "pagination.perPage": function(perPage) {
      this.$store.commit("survey/setPagination", {
        ...this.pagination,
        currentPage: 1
      });
      if (this.usertype === USER_TYPE.AIRPORT) {
        this.getAirportSurveys(1, perPage, this.searchQuery);
      } else {
        this.getSurveys(1, perPage, this.searchQuery);
      }
    }
  }
};
</script>

<style lang="scss">
.items-center {
  align-items: center;
}
.copy-icon {
  color: #0abab5;
  font-size: 14px;
  margin-left: 8px;
  cursor: pointer;
  position: relative;
  top: 10px;
}
#surveymap {
  width: 100%;
  height: 540px;
  margin: 10px 0px 0px 0px;
  padding: 0px;
}

img.resize {
  max-width: 80%;
  max-height: 80%;
}

img.fullsize {
  max-width: 800px;
  max-height: 580px;
}
.survey-list-table .md-table-cell-container {
  padding: 0;
}
.page-old-survey {
  .document-title {
    min-width: 200px;
    max-width: 30%;
    flex: 0 1 30%;
  }
  .algin-center {
    display: flex;
    align-items: center;
  }
  .notice-wrapper {
    margin: 20px 0;
    border: 1px solid #ccc;
    .md-checkbox .md-checkbox-label {
      color: #333;
    }
    .notice-content {
      padding: 0 32px;
    }
    .tips {
      font-size: 12px;
      color: #999;
    }
    .notice-title {
      .material-icons {
        margin-left: 10px;
      }
    }
    &.active {
      border-color: red;
      .notice-title {
        color: red;
      }
    }
  }
}
</style>
